import { AUTH_HEADER } from '@/core/constants/http-headers'
import { IHttpClient } from '@/core/services/http'
import { ITokenService } from '@/core/services/tokens/token.service.interface'
import { UnauthorizedError } from '@/core/types/errors/http-error'
import { UpdatePasswordDto } from '../types/dtos/update-password.dto'

export function createUpdatePasswordUseCase({
  httpClient,
  tokenService,
}: {
  httpClient: IHttpClient
  tokenService: ITokenService
}) {
  return async function (dto: UpdatePasswordDto) {
    const { token } = await tokenService.getToken()

    if (!token) {
      throw new UnauthorizedError()
    }
    await httpClient
      .version('v1')
      .addHeaders(AUTH_HEADER(token))
      .post('/website/buyer/update-password', dto)
  }
}
